import { useRef, useState } from 'react';
import { FormCheckboxGroupField } from '@mews/framework';
import { SearchInput } from '@optimus-web/core';
import { KeyValue } from '@mews/enums';
import { includesLowerCase } from '../../../../common/utils';
import { useCurrentEnterpriseAttachments } from '../../../hooks/useCurrentEnterpriseAttachments';
import { useCurrentReservation } from '../../../hooks/useCurrentReservation';
import { EmptyAttachmentState } from './EmptyAttachmentState';

export const SelectAttachmentField = (props: { name: string; previouslySelected?: string[] }) => {
    const serviceId = useCurrentReservation()?.serviceId;
    const [searchValue, setSearchValue] = useState<string>('');
    const ref = useRef<HTMLInputElement>(null);
    const attachments = useCurrentEnterpriseAttachments().filter(
        (attachment) => serviceId === undefined || attachment.services?.some(({ id }) => id === serviceId)
    );
    const options = attachments
        ?.filter(({ customName }) => includesLowerCase(customName, searchValue))
        ?.map((attachment) => ({
            label: attachment.customName,
            value: attachment.id,
            name: attachment.id,
        }));

    const handleEnterPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === KeyValue.Enter) {
            const searchVal = ref.current?.value || '';
            setSearchValue(searchVal.toString());

            event.preventDefault();
            event.stopPropagation();
        }
    };

    return attachments.length === 0 ? (
        <EmptyAttachmentState />
    ) : (
        <>
            <SearchInput
                onChange={(_, value) => setSearchValue(value.toString())}
                onSearch={(value) => setSearchValue(value.toString())}
                name="selectAttachmentSearchField"
                onClear={() => setSearchValue('')}
                value={searchValue}
                clearable
                onKeyDown={handleEnterPress}
                ref={ref}
            />
            <FormCheckboxGroupField
                defaultValue={props.previouslySelected}
                options={options}
                size="large"
                rowGap="100"
                {...props}
            />
        </>
    );
};
